import API from "./common"

export const searchMember = async (keyword) => {
  const response = await API.post("/api/partner/v2/member_search/search", {
    keyword: keyword,
  })
  return response.data
}

export const getMemberById = async (id) => {
  const response = await API.get(`/api/partner/v2/member_search/${id}`)
  return response.data
}

export const getMemberPointHistory = async (id) => {
  const response = await API.get(`/api/partner/v2/member_search/${id}/history`)
  return response.data
}

export const getMemberAvailablePrivilege = async (id) => {
  const response = await API.get(
    `/api/partner/v2/member_search/${id}/sub_v2/privilege`
  )
  return response.data.results.data
}

export const usePrivilege = async (memberId, id, params, series = null) => {
  let url = `/api/partner/v2/member_search/${memberId}/sub_v2/privilege/${id}/use`
  if (series) {
    url = `${url}?series_ref=${series}`
  }

  const response = await API.post(url, params)
  return response.data.results
}

export const confirmUseCode = async (memberId, pid, code, password) => {
  const params = {
    code: code,
    pid: pid,
    password: password,
  }
  const response = await API.post(
    `/api/partner/v2/member_search/${memberId}/privilege/confirm`,
    params
  )
  return response.data
}

export const confirmMultipleUseCode = async (memberId, pid, code, password) => {
  const params = {
    code: code,
    pid: pid,
    password: password,
  }
  const response = await API.post(
    `/api/partner/v2/member_search/${memberId}/privilege/confirm_multiple`,
    params
  )
  return response.data
}

export const activateCard = async (memberId, params) => {
  const response = await API.post(
    `/api/partner/v2/member/${memberId}/card_activate`,
    params
  )
  return response.data
}

export const createUser = async (params) => {
  let url = ""
  if (process.env.REACT_APP_OVERRIDE_LOGIN_METHOD === "legacy") {
    url = "/api/partner/v2/member/register_nosso"
  } else {
    url = "/api/partner/v2/member/register"
  }

  const response = await API.post(url, params)
  return response
}

export const updateUser = async (params) => {
  const response = await API.post("/api/partner/v2/member/update", params)
  return response.data
}

export const getRewardType = async () => {
  const response = await API.get("/api/partner/v2/privilege/reward_type")
  return response.data
}

export default {
  searchMember,
  getMemberById,
  getMemberPointHistory,
  getMemberAvailablePrivilege,
  usePrivilege,
  confirmUseCode,
  confirmMultipleUseCode,
  activateCard,
  createUser,
  updateUser,
}



// WEBPACK FOOTER //
// ./src/api/search.js